(() => {
  function getCountElements() {
    return Array.from(document.querySelectorAll('[data-cart-count], [data-mobile-cart-count]'));
  }

  function createCartConfettiBurst(target) {
    if (!target) return;

    const existing = target.querySelector('.site-header__cart-burst');
    if (existing) existing.remove();

    const burst = document.createElement('span');
    burst.className = 'site-header__cart-burst';

    const colors = ['#89CCF1', '#FBE797', '#6F8FF7', '#FFFFFF', '#89CCF1', '#FBE797'];
    const pieceCount = 22;

    for (let i = 0; i < pieceCount; i += 1) {
      const piece = document.createElement('span');
      const isRibbon = i % 5 === 0 || i % 7 === 0;

      piece.className = `site-header__cart-burst-piece${isRibbon ? ' site-header__cart-burst-piece--ribbon' : ''}`;

      const angle = (Math.PI * 2 * i) / pieceCount + (Math.random() * 0.26 - 0.13);
      const distance = 42 + Math.random() * 26;
      const tx = Math.cos(angle) * distance;
      const ty = Math.sin(angle) * distance;
      const width = isRibbon ? 3 + Math.random() * 2 : 4 + Math.random() * 4;
      const height = isRibbon ? 14 + Math.random() * 8 : 7 + Math.random() * 8;
      const rotation = `${Math.round(Math.random() * 220)}deg`;
      const delay = `${Math.round(Math.random() * 110)}ms`;
      const color = colors[i % colors.length];
      const radius = isRibbon ? '999px 999px 4px 999px' : Math.random() > 0.45 ? '999px' : '2px';

      piece.style.setProperty('--tx', `${tx}px`);
      piece.style.setProperty('--ty', `${ty}px`);
      piece.style.setProperty('--w', `${width}px`);
      piece.style.setProperty('--h', `${height}px`);
      piece.style.setProperty('--r', rotation);
      piece.style.setProperty('--d', delay);
      piece.style.setProperty('--c', color);
      piece.style.setProperty('--radius', radius);

      burst.appendChild(piece);
    }

    target.appendChild(burst);

    window.setTimeout(() => {
      burst.remove();
    }, 1100);
  }

  function burstCartCount() {
    const countElements = getCountElements();

    countElements.forEach((countEl) => {
      countEl.classList.remove('is-bursting');
      void countEl.offsetWidth;
      countEl.classList.add('is-bursting');

      const burstTarget =
        countEl.closest('[data-mobile-cart-toggle]') ||
        countEl.closest('[data-cart-toggle]') ||
        countEl.parentElement;

      if (burstTarget) {
        const rect = burstTarget.getBoundingClientRect();
        const isVisible = rect.width > 0 && rect.height > 0;

        if (isVisible) {
          createCartConfettiBurst(burstTarget);
        }
      }

      window.setTimeout(() => {
        countEl.classList.remove('is-bursting');
      }, 1020);
    });
  }

  document.addEventListener('cart:burst', burstCartCount);

  window.HohoCartEffects = {
    burstCartCount
  };
})();